import { InjectionToken } from '@angular/core';

/**
 * 'urls' deep merge
 * 'reloadIntervalMs' periodic reload 
 * 'preload' load in init
 */
export interface ConfigOptions {
    urls: string[];
    reloadIntervalMs?: number;
    preload?: boolean;
}

export const CONFIG_OPTIONS = new InjectionToken<ConfigOptions>('CONFIG_OPTIONS');
